import { $, $$ } from '@/utilities/helpers';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { setWithExpiry, getWithExpiry } from '@/utilities/helpers';
import Choices from 'choices.js'
import { ENDPOINTS } from '@/components/constants';


import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import ImageEditor from '@uppy/image-editor';
import ThumbnailGenerator from '@uppy/thumbnail-generator';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/image-editor/dist/style.min.css';

window.Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

const SIMULATED_DELAY = 789;

let $inductionItems = $$('.js-induction-item');
let $inductionNavItems = $$('.js-induction-nav');
let $skipItems = $$('.js-skip');

window.completed_steps = [];


let current_step = 'homescreen';

let ordered_steps = [
    'biometric',
    'homescreen',
    'avatar',
    'favourites',
    'final',
];

let $backButton = $('.js-induction-back');

if ($backButton) {
    $backButton.addEventListener('click', (e) => {
        e.preventDefault();
        let next_step = ordered_steps.indexOf(current_step) - 1;
        if (ordered_steps[next_step] === 'homescreen' && window.innerWidth > 768) {
            next_step = ordered_steps.indexOf(current_step) - 2;
        }
        changeSteps(ordered_steps[next_step], false);
    });
}

const changeSteps = (id = 'biometric', redirect = true) => {

    if (redirect && window.completed_steps.includes(id)) {
        let next_step_index = ordered_steps.indexOf(id) + 1;
        if (next_step_index < ordered_steps.length) {
            return changeSteps(ordered_steps[next_step_index]);
        }
    }

    if (id === 'biometric') {
        $('.js-induction-back').style.display = 'none';
    } else {
        $('.js-induction-back').style.display = 'block';
    }



    current_step = id;

    $inductionItems.forEach(item => item.classList.toggle('active', item.dataset.step === id));
    $inductionNavItems.forEach(item => item.classList.toggle('active', item.dataset.step === id));

    if (id === 'homescreen' && window.innerWidth > 768) {
        skipItem();
    }

};




$inductionNavItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        e.preventDefault();
        let id = item.dataset.step;
        console.log(id);
        changeSteps(id, false);
    });
});


const skipItem = () => {
    const url = new URL(ENDPOINTS.COMPLETE_INDUCTION_STEP);

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ step: current_step })
    })
        .then(response => response.json())
        .then((data) => {
            let next_step = ordered_steps.indexOf(current_step) + 1;
            if (current_step === 'final') {
                window.location.reload();
            } else {
                changeSteps(ordered_steps[next_step]);
            }
        })
}


$skipItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        e.preventDefault();
        skipItem();
    });
});


const initInduction = () => {

    // Get a reference to the file input element
    const avatar = document.querySelector('#uppyinduction');

    let $saveButtonInduction = document.querySelector('.js-save-avatar-button-induction');

    if (!$('.induction')) return;

    $('.induction').style.display = 'flex';

    let uppyInduction = new Uppy({
        restrictions: {
            maxNumberOfFiles: 1,
            allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg']
        }
    }).use(Dashboard, {
        singleFileFullScreen: true,
        inline: true,
        proudlyDisplayPoweredByUppy: false,
        target: '#uppyinduction',
        width: 360,
        height: 360,
        restrictions: {
            maxNumberOfFiles: 1,
            allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg']
        },
        showAddMoreButton: false,
    })
        .use(ImageEditor, {
            aspectRatio: 1,
            target: Dashboard,
            actions: {
                revert: true,
                rotate: false,
                granularRotate: false,
                flip: true,
                zoomIn: true,
                zoomOut: true,
                cropSquare: false,
                cropWidescreen: false,
                cropWidescreenVertical: false,
            },
            cropperOptions: {
                aspectRatio: 1,
                cropBoxMovable: false,
                cropBoxResizable: false,
                guides: false,
                center: false,
                autoCrop: true,
                autoCropArea: 1,
                movable: true,
                rotatable: false,
                dragMode: 'move',
                viewMode: 1,
            },
        })
        .use(ThumbnailGenerator, { thumbnailWidth: 300, thumbnailHeight: 300 });

    uppyInduction.on('file-added', (file, preview) => {
        setTimeout(() => {
            if (!avatar.dataset.url)
                $('.uppy-Dashboard-Item-action--edit').click();
        }, 100);
        $saveButtonInduction.removeAttribute('disabled');
    });

    uppyInduction.on('file-editor:start', (file) => {
        $saveButtonInduction.setAttribute('disabled', 'disabled');
    });

    uppyInduction.on('file-editor:complete', (file) => {
        $saveButtonInduction.removeAttribute('disabled');
    });



    if (avatar.dataset.url) {
        // Function to preload an image into Uppy
        function preloadImage(fileUrl, fileName = 'avatar') {
            fetch(fileUrl)
                .then((response) => response.blob()) // Convert image to Blob
                .then((blob) => {
                    const file = new File([blob], fileName, { type: blob.type });

                    uppyInduction.addFile({
                        name: fileName,
                        type: blob.type,
                        data: file, // File object
                        source: 'local',
                        isRemote: false,
                    });
                })
                .catch((error) => console.error('Error loading image:', error));
        }

        // Call this function with the URL of the image you want to preload
        preloadImage(avatar.dataset.url);

    }


    /**
     * 
     * Handle a form response
     * 
     * @param {object} response 
     */
    const handleFormResponse = (response) => {
        setTimeout(() => {
            Toast.fire({
                icon: (response.status === 'ok') ? 'success' : 'error',
                title: response.message
            })
        }, SIMULATED_DELAY);
    };


    /**
    * 
    * Handle a form submission
    * 
    * @param {element} $formSection 
    * @param {object} data 
    * @param {string} method 
    */
    const saveFormSubmissionInduction = ($formSection, url, data, method = 'POST') => {
        fetch(url, { method, body: JSON.stringify(data) })
            .then(response => response.json())
            .then(data => handleFormResponse(data))
            .finally(() => {
                setTimeout(() => {
                    $formSection.classList.remove('busy')
                    skipItem();
                }, SIMULATED_DELAY);
            });
    };



    // Handle form submission
    $saveButtonInduction.addEventListener('click', (e) => {

        e.preventDefault();

        // Get the form section
        let $formSection = $('.js-induction-item .js-form-section');


        // Prevent multiple submissions with a busy state
        $formSection.classList.add('busy');


        function getFileDataURL(fileId, callback) {
            const file = uppyInduction.getFile(fileId);
            if (file) {
                const reader = new FileReader();
                reader.onload = function (event) {
                    const dataURL = event.target.result; // This is the Data URL
                    callback(dataURL); // Execute the callback with the Data URL
                };
                reader.readAsDataURL(file.data); // Read the file as Data URL
            } else {
                console.error('File not found!');
            }
        }

        // Usage with form submission
        const file = uppyInduction.getFiles()[0]; // Get the first uploaded file
        if (file) {

            getFileDataURL(file.id, function (dataURL) {
                // Call saveFormSubmission once the Data URL is ready
                saveFormSubmissionInduction($formSection, $saveButtonInduction.dataset.apiUrl, { avatar: dataURL });
            });
        } else {
            console.error('No file selected');
        }
    });


    let topics = [];

    let handleTopicsFavourites = (e) => {
        if (window.favouritesChoice) window.favouritesChoice.destroy();

        let $favourites = $('.js-favourites-induction');
        $favourites.innerHTML = '';

        topics.forEach(topic => {
            let option = document.createElement('option');
            option.value = topic.title;
            option.text = topic.title;
            $favourites.appendChild(option);
        });

        window.favouritesChoice = new Choices($('.js-favourites-induction'), {
            searchEnabled: true,
            removeItems: true,
            removeItemButton: true,
            searchChoices: true,
            searchResultLimit: 5,
            shouldSort: false,
            itemSelectText: '',
            placeholder: true,
            placeholderValue: 'Select some topics to favourite',
        });
    }


    // Fetch a pre cached JSON file from our CDN
    fetch('/snippetsearch/topicsall')
        .then((response) => response.json())
        .then(data => {
            topics = data.data;
            handleTopicsFavourites();
        });

}

let safari_instructions = /*html*/`
    <div class="pwa-instructions">
        <p>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M276.03-68Q249-68 230.5-86.65T212-132.31v-407.38q0-27.01 18.65-45.66Q249.3-604 276.31-604h76.31q11.06 0 18.53 7.41 7.46 7.4 7.46 18.38 0 10.98-7.46 18.59-7.47 7.62-18.53 7.62h-76.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v407.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-407.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85h-76.31q-11.06 0-18.53-7.4-7.46-7.41-7.46-18.39t7.46-18.59q7.47-7.62 18.53-7.62h76.31q27.01 0 45.66 18.65Q748-566.7 748-539.69v407.38q0 27.01-18.66 45.66Q710.68-68 683.65-68H276.03ZM454-778.23l-49.17 49.17q-7.68 7.68-18.14 8.06-10.46.39-19.24-7.92-8.22-8.31-8.03-18.58.2-10.27 8.38-18.45l90.02-90.02q9.72-9.72 22.36-9.72 12.65 0 22.13 9.85l89.77 89.77q8.3 8.3 8.5 18.07.19 9.77-8.03 18.08-8.78 8.31-19.02 8.31-10.25 0-18.22-8.31L506-778.23V-372q0 11.07-7.41 18.53-7.4 7.47-18.38 7.47-10.98 0-18.59-7.47Q454-360.93 454-372v-406.23Z"/></svg>
            First click Share
        </p>
        <p>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M223.31-164q-24.56 0-41.94-17.37Q164-198.75 164-223.31v-513.38q0-24.56 17.37-41.94Q198.75-796 223.31-796h513.38q24.56 0 41.94 17.37Q796-761.25 796-736.69v513.38q0 24.56-17.37 41.94Q761.25-164 736.69-164H223.31ZM216-336v107.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h503.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-336H216Zm0-52h528v-343.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H228.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-388Zm0 52v120-120Z"/></svg>
            Then click Add to Dock
        </p>
    </div>`;

let brave_instructions = /*html*/`
    <div class="pwa-instructions">
        <p>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M276.03-68Q249-68 230.5-86.65T212-132.31v-407.38q0-27.01 18.65-45.66Q249.3-604 276.31-604h76.31q11.06 0 18.53 7.41 7.46 7.4 7.46 18.38 0 10.98-7.46 18.59-7.47 7.62-18.53 7.62h-76.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v407.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-407.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85h-76.31q-11.06 0-18.53-7.4-7.46-7.41-7.46-18.39t7.46-18.59q7.47-7.62 18.53-7.62h76.31q27.01 0 45.66 18.65Q748-566.7 748-539.69v407.38q0 27.01-18.66 45.66Q710.68-68 683.65-68H276.03ZM454-778.23l-49.17 49.17q-7.68 7.68-18.14 8.06-10.46.39-19.24-7.92-8.22-8.31-8.03-18.58.2-10.27 8.38-18.45l90.02-90.02q9.72-9.72 22.36-9.72 12.65 0 22.13 9.85l89.77 89.77q8.3 8.3 8.5 18.07.19 9.77-8.03 18.08-8.78 8.31-19.02 8.31-10.25 0-18.22-8.31L506-778.23V-372q0 11.07-7.41 18.53-7.4 7.47-18.38 7.47-10.98 0-18.59-7.47Q454-360.93 454-372v-406.23Z"/></svg>
            First click Share this page in the address bar
        </p>
        <p>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M479.8-357.54q-6.43 0-11.96-2.31-5.53-2.3-10.15-6.92L335.31-489.15q-7.92-7.83-7.81-18.34.12-10.51 8.33-18.82 8.79-8.3 18.86-8.11 10.08.19 18.39 8.5L454-444v-326q0-11.07 7.41-18.53 7.4-7.47 18.38-7.47 10.98 0 18.59 7.47Q506-781.07 506-770v326l81.92-81.92q7.59-7.92 18.03-7.81 10.43.12 19.22 8.42 8.21 8.31 8.02 18.58-.19 10.27-8.5 18.58L502.31-366.77q-5.02 4.62-10.55 6.92-5.53 2.31-11.96 2.31ZM276.03-212q-27.03 0-45.53-18.65T212-276.31v-34.46q0-11.07 7.41-18.53 7.4-7.47 18.38-7.47 10.98 0 18.59 7.47 7.62 7.46 7.62 18.53v34.46q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-34.46q0-11.07 7.4-18.53 7.41-7.47 18.39-7.47t18.59 7.47q7.62 7.46 7.62 18.53v34.46q0 27.01-18.66 45.66Q710.68-212 683.65-212H276.03Z"/></svg>            
            Then click Save page as
        </p>
    </div>`;


let instructions;

async function isBrave() {
    if (navigator.brave) {
        return await navigator.brave.isBrave();
    }
    return false;
}

isBrave().then((result) => {
    instructions = brave_instructions;
});

function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

setTimeout(() => {
    if (isSafari()) {
        instructions = safari_instructions;
    }
}, 1000);



const supportsInstallPrompt = 'onbeforeinstallprompt' in window;

let $installPWA = $('.js-add-to-homescreen');

let $installPWAInstructions = $('.js-show-add-to-homescreen-instructions');

if ($installPWAInstructions) {
    $installPWAInstructions.addEventListener('click', () => {
        $('.js-induction-item-pwa').classList.add('completed');
    });
}


window.addEventListener('load', () => {
    if ($installPWA) {
        $installPWA.disabled = !supportsInstallPrompt;
    }
});

window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault();
    window.deferredPrompt = e;
});

if ($installPWA) {

    let style = document.createElement('style');

    style.innerHTML = `
        .swal2-container {
            z-index:9999999 !important;
        }
        .swal2-title{
            font-size: 1.6rem;
            line-height: 1.3;
        }`;

    document.head.appendChild(style);

    $installPWA.addEventListener('click', () => {
        if (window.deferredPrompt) {
            window.deferredPrompt.prompt();
        } else if (!supportsInstallPrompt || !window.deferredPrompt) {
            Swal.fire({
                title: 'To install DermNet PRO on your device, please follow these instructions:',
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'Okay',
                html: instructions
            }).then((result) => {

            })
        }
    });
}



let $addFavourites = $('.js-add-favourites');

if ($addFavourites) {

    $addFavourites.addEventListener('click', (e) => {
        e.preventDefault();
        let selected = window.favouritesChoice.getValue();
        selected = selected.map(item => item.value);
        if (selected.length > 0) {
            let url = new URL(ENDPOINTS.ADD_FAVOURITES);
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ titles: selected.join(',') })
            })
                .then(response => response.json())
                .then((data) => {
                    skipItem();
                })
        }
    });
}

if ($inductionItems.length) {
    const url = new URL(ENDPOINTS.FETCH_COMPLETED_INDUCTION_STEPS);

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    })
        .then(response => response.json())
        .then((data) => {
            if (data?.data?.length === 0) return;

            data.data.forEach(step => {
                if (step.complete) window.completed_steps.push(step.step);
            });

            if (window.completed_steps.length < 5) {
                setTimeout(() => {
                    changeSteps('biometric', true);
                    initInduction();
                }, 1000);
            }
        })

}


const handleRegisterWebAuthn = async () => {
    $('.js-induction-item-biometrics').classList.add('completed');
}

let $addBiometric = $('.js-add-bio-induction');

if ($addBiometric) {
    $addBiometric.addEventListener('click', (e) => {
        e.preventDefault();
        registerWebAuthn(false, handleRegisterWebAuthn);
    });
}
